import { postForm, ENDPOINTS } from "../../../services/shopify";

const requestPaymentAppTempToken = (values) => {
  postForm({
    endpoint: ENDPOINTS.AUTHORIZE,
    gatewayName: values?.gatewayName,
    body: values,
    withRedirect: true,
  });
};

export default requestPaymentAppTempToken;
